import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './i18n'; // Import the i18n configuration
import {
  Text,
  Badge,
  Box,
  Page,
  PageSection,
  Card,
  Cell,
  Layout,
  MarketingLayout,
  Button,
  Image,
  WixDesignSystemProvider,
  Modal,
  AnnouncementModalLayout,
  FormField,
  CheckToggle,
  Input
} from '@wix/design-system';
import "@wix/design-system/styles.global.css";
import { PremiumFilled } from '@wix/wix-ui-icons-common';
import { ReactTagManager } from 'react-gtm-ts';

const tagManagerArgs = {
  code: 'GTM-WZQPMC7'
};

const appName = {
  '99380718-9366-474d-a7ca-e62ac683cd5f': '綠界科技 ECPay 支付整合',
  '4f759c16-8198-4dd6-85d7-ecd0a086af9b': '綠界科技 ECPay 物流整合',
};

function App() {
  const { t } = useTranslation();

  ReactTagManager.init(tagManagerArgs);
  const appId = new URLSearchParams(window.location.search).get('appId');
  const siteUrl = new URLSearchParams(window.location.search).get('siteUrl');
  const lang = new URLSearchParams(window.location.search).get('lang');
  const shouldShowUpgradeCard = !!appId && Object.prototype.hasOwnProperty.call(appName, appId);
  const shouldShowSubscriptionsCard = lang === 'zh';

  const VeloCard = (
    <Cell span={12}>
      <Card>
        <MarketingLayout
          size="medium"
          title={t('velo.title')}
          description={t('velo.description')}
          actions={<Button as="a" href="https://www.certifiedcode.us/support/contact" target="_blank">{t('velo.button')}</Button>}
          image={
            <Image height={"200px"} fit="contain" transparent={true} src='https://static.wixstatic.com/media/5305c5_385630a87104449b8f3c457bb3b54ad6~mv2_d_3840_1600_s_2.jpg'></Image>
          }
        />
      </Card>
    </Cell>
  );

  const UpgradeIntegrationCard = (
    <Cell span={12}>
      <Card>
        <MarketingLayout
          size="medium"
          title="免費升級整合"
          description="現有版本已停止維護。新版本提供更順暢的結帳體驗，並支援可自訂的結帳選項。"
          actions={<Button as="a" href="https://www.flows.tw/products/request-demo" target="_blank">聯絡我們</Button>}
          hiddenBadge
          alignItems="stretch"
        />
      </Card>
    </Cell>
  );

  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <Page height='100vh'>
        <Page.Header
          title={(appName as any)[(appId as any)] || t('title')}
          subtitle={t('subtitle')}
          actionsBar={<Button as="a" href={t('ctaLink')} target="_blank" skin="premium" prefixIcon={<PremiumFilled />}>{t('actionsBar')}</Button>}
        />
        <Page.Content>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {shouldShowUpgradeCard && (
              <Layout gap="24px">
                {UpgradeIntegrationCard}
              </Layout>
            )}
            <Layout gap="24px">
              {VeloCard}
            </Layout>
            <Layout gap="24px">
              <Cell>
                <PageSection title={t('recommended.title')} showDivider />
              </Cell>
              <Cell span={6}>
                <Card>
                  <MarketingLayout
                    title={t('wixDiscountCard.title')}
                    description={t('wixDiscountCard.description')}
                    actions={
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        <Button as="a" href="https://www.certifiedcode.us/pricing/sites?code=TFWFGU3974" target="_blank" size="small">
                          {t('wixDiscountCard.editorPlansButton')}
                        </Button>
                        <Button as="a" href="https://www.certifiedcode.us/pricing/studio-sites?code=TFWFGU3974" target="_blank" size="small" priority="secondary">
                          {t('wixDiscountCard.studioPlansButton')}
                        </Button>
                      </div>
                    }
                    size="tiny"
                    hiddenBadge
                    alignItems="stretch"
                  />
                </Card>
              </Cell>
              {shouldShowSubscriptionsCard && (
                <Cell span={6}>
                  <Card>
                    <MarketingLayout
                      title="銷售訂閱方案"
                      description="在您的 Wix 網站上銷售會員、課程或定期服務，建立可持續的收入模式。"
                      actions={
                        <Button as="a" href="https://www.flows.tw/sell-subscriptions" target="_blank" size="small">
                          了解更多
                        </Button>
                      }
                      size="tiny"
                      hiddenBadge
                      alignItems="stretch"
                    />
                  </Card>
                </Cell>
              )}
            </Layout>
          </div>
        </Page.Content>
      </Page>
    </WixDesignSystemProvider>
  );
}

export default App;
